import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
let cmsPromise = null;

export const fetchCms = () => {
  if (!cmsPromise) {
    cmsPromise = fetch(`${API}/api/cms/public`)
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}));
  }
  return cmsPromise;
};

export const cmsImageUrl = (url) => (url && url.startsWith('/api/') ? `${API}${url}` : url);

export const useCms = (section, fallback) => {
  const [data, setData] = useState(fallback);
  useEffect(() => {
    let alive = true;
    fetchCms().then((c) => {
      if (alive && c && c[section]) setData((prev) => ({ ...prev, ...c[section] }));
    });
    return () => { alive = false; };
  }, [section]);
  return data;
};
